import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService, SessionService } from 'brainloper-ui';
import { Module } from './models/administration/module';
import { AuthenticationService } from './services/authentication.service';




@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(
    private router: Router,
    private session : SessionService,
    private storage : LocalStorageService,
    private authenticationService : AuthenticationService
  ){
  }

  canActivate($event:any):boolean{
    if(this.storage.get('token') && this.storage.get('userId')){
      //console.log($event.routeConfig.path )
      if($event.routeConfig.path != 'notificaciones' && $event.routeConfig.path != 'inicio'){
        let v = this.validateRouter($event)
        if(!v){
          // Evitar redirigir si ya estamos en /inicio
          const currentUrl = $event?._routerState?.url || '';
          if (currentUrl !== '/inicio') {
            this.router.navigate(['/inicio']);
          }
          return false;
        }
      }

      console.log('initSession:', this.storage.get<boolean>('initSession'));
      if(!this.storage.get<boolean>('initSession')){
        this.authenticationService.Logout();
        return false;
      }
      return true;
    }else{
      // Guardar la URL solicitada (incluye query params) para redirigir después de login
      try{
        const requestedUrl = $event?._routerState?.url || '/inicio'
        this.storage.set<string>('postLoginRedirect', requestedUrl)
      }catch{}
      this.router.navigate(['/'])
      return false
    }
  }

  private validateRouter($event:any):boolean{
    const modules: Module[] = this.storage.get<Module[]>('modules') || [];

    const fullUrl: string = $event?._routerState?.url || '';
    const baseUrl = fullUrl.split('?')[0]; // quitar query params

    // Coincidencia directa con módulo principal
    let m = modules.find(x => x.route === baseUrl);
    if(m) return true;

    // Intentar con submódulos (ignorando query)
    for(const element of modules){
      if(element.subModules){
        for(const subElement of element.subModules){
          const subRouteBase = (subElement.route || '').split('?')[0];
          if(subRouteBase === baseUrl) return true;
          // Comparación por último segmento del path configurado vs path de la ruta angular
          const segs = subRouteBase.split('/').filter(s=>!!s);
          const last = segs[segs.length-1];
          if(last === $event.routeConfig?.path){
            return true;
          }
        }
      }
    }
    return false;
  }

}
